"use strict";

var _loadjs = require("loadjs");

var _loadjs2 = _interopRequireDefault(_loadjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userCanBeTracked = window.Shopify.userCanBeTracked;
var userDataCanBeSold = window.Shopify.userDataCanBeSold;

window.heap = window.heap || [], heap.load = function (e, t) {
  window.heap.appid = e, window.heap.config = t = t || {};
  var r = t.forceSSL || "https:" === document.location.protocol,
      a = document.createElement("script");
  a.type = "text/javascript", a.async = !0, a.src = (r ? "https:" : "http:") + "//cdn.heapanalytics.com/js/heap-" + e + ".js";
  var n = document.getElementsByTagName("script")[0];
  n.parentNode.insertBefore(a, n);
  for (var o = function o(e) {
    return function () {
      heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
    };
  }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], c = 0; c < p.length; c++) {
    heap[p[c]] = o(p[c]);
  }
};
heap.load("2300875174");

if (userCanBeTracked) {
  var gtag = function gtag() {
    dataLayer.push(arguments);
  };

  if (userDataCanBeSold) {
    heap.identify(window.userData.email);
    heap.addUserProperties({
      Name: window.userData.name,
      email: window.userData.email,
      CustomerID: window.userData.id,
      TotalSpent: window.userData.totalSpent
    });
  }

  (0, _loadjs2.default)(["https://www.googletagmanager.com/gtag/js?id=AW-961638217", "https://www.googletagmanager.com/gtag/js?id=AW-787860359", "https://www.googletagmanager.com/gtag/js?id=G-FSYNS9LBTD", "https://www.googleadservices.com/pagead/conversion.js", "https://www.googleadservices.com/pagead/conversion.js"]);
  window.dataLayer = window.dataLayer || [];

  gtag("js", new Date());

  if (userDataCanBeSold) {
    gtag("config", "AW-961638217");
    gtag("config", "AW-787860359");
    gtag('config', 'G-FSYNS9LBTD');
  } else {
    window.google_restricted_data_processing = true;
    gtag("config", "AW-961638217", { restricted_data_processing: true });
    gtag("config", "AW-787860359", { restricted_data_processing: true });
    gtag('config', 'G-FSYNS9LBTD', { restricted_data_processing: true });
  }

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-M9DMPDR");
}